import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'tnb-confirm-dialog',
    template: `
        <div data-qa="confirm-dialog">
          @if (data.title) {
            <h1 mat-dialog-title data-qa="confirm-dialog-title">{{data.title}}</h1>
          }
          <mat-dialog-content data-qa="confirm-dialog-content" [innerHTML]="data.message"></mat-dialog-content>

          <mat-dialog-actions style="justify-content: flex-end;">
            @if (data.cancelMessage) {
              <button matButton="outlined" data-qa="confirm-dialog-cancel-button" mat-dialog-close>
                  @if (data.cancelIcon) {
                      <mat-icon [svgIcon]="data.cancelIcon.startsWith('innogy_picto') ? data.cancelIcon : null">
                          {{ data.cancelIcon }}
                      </mat-icon>
                  }
                {{ data.cancelMessage }}
              </button>
            }
            <button matButton="filled"
              cdkFocusInitial
              data-qa="confirm-dialog-submit-button"
              [mat-dialog-close]="true"
              class="button-{{ data.confirmColor }}">
                @if (data.confirmIcon) {
                    <mat-icon [svgIcon]="data.confirmIcon.startsWith('innogy_picto') ? data.confirmIcon : null">
                         {{ data.confirmIcon }}
                    </mat-icon>
                }
              {{ data.confirmMessage }}
            </button>
          </mat-dialog-actions>
        </div>
        `,
    styles: [
        `
            h1 {
                font-family: 'innogy-regular', Roboto, "Helvetica Neue", sans-serif !important;
                font-weight: bold !important;
            }
        `,
    ],
    standalone: false,
})
export class ConfirmDialogComponent {
    data = inject<{
    message: string;
    title?: string;
    cancelMessage: string;
    confirmMessage: string;
    confirmColor: 'primary' | 'warn' | 'accent';
    cancelIcon?: string;
    confirmIcon?: string;
}>(MAT_DIALOG_DATA);
}
